import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const confluence = defineConnector({
  identifier: "confluence",
  name: "Confluence",
  tagLine: "Team wiki and documentation",
  keywords:
    "atlassian wiki docs documentation knowledge base intranet pages spaces",
  logo,
  protocol: "http",
  tags: ["featured", "productivity", "documents"],
  defaultUrlPattern: () => "https://.*\\.atlassian\\.net/wiki/rest/api/.*",
  auth: (app) =>
    basicAuth({
      username: app.config.email,
      password: app.secret.apiToken,
    }),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [this page](https://id.atlassian.com/manage-profile/security/api-tokens) signed in as the account you’d like associated with your automated Confluence actions. (We recommend a service account.)\n\nClick **Create API token** and give it a label when asked.",
        },
      ],
    },
    {
      title: "Copy and paste the API token here",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
    {
      title: "Enter the account’s email address",
      items: [
        {
          kind: "input",
          label: "API token account email",
          placeholder: "you@example.com",
          required: true,
          target: { kind: "configuration", field: "email" },
        },
      ],
    },
    {
      title: "Enter your Confluence account domain",
      items: [
        {
          kind: "hostname",
          label: "Confluence account domain",
          placeholder: "example.com",
          required: true,
          target: { kind: "configuration", field: "domain" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/wiki/rest/api/user/current`,
  },
  publicEnvVars: ({ domain, email }) => ({
    CONFLUENCE_URL: domain ? `https://${domain}` : "",
    CONFLUENCE_EMAIL: email || "",
  }),
});
